import { useDispatch, useSelector } from 'react-redux';

import {
  AutoBookingError,
  clearAutoBookingError as clearAutoBookingErrorAction,
} from 'actions/AutoBookingActions';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getAppointment } from 'selectors/appointment';

import Button from 'components/Button';
import Modal from 'components/Modal/Modal';

import s from './AutoBookingErrorModal.module.css';

const getErrorText = (error: AutoBookingError | null): string => {
  switch (error) {
    case 'DATE_TAKEN':
      return 'The date you selected is no longer available. Please select a different date for your appointment.';
    case 'TIME_TAKEN':
      return 'The time you selected is no longer available. Please select a different appointment time.';
    case 'INVALID_SERVICES':
      return 'We are not able to book the requested appointment. Please try again.';
    default:
      return '';
  }
};

export const AutoBookingErrorModal = () => {
  const { autoBookError: error } = useSelector(getAppointment) || {};
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();

  const closeModal = () => {
    dispatch(clearAutoBookingErrorAction());
  };

  return error ? (
    <Modal title="Oops!" showClose={false} className={s.modal}>
      {getErrorText(error)}
      <Button className={s.button} onClick={closeModal}>
        Okay!
      </Button>
    </Modal>
  ) : null;
};
